import { tickLabel } from "../util/CertificateUtils";
import ReadOnlyTable from "./ReadOnlyTable";

const CostAllocationTable = ({ rows = [], showTick = false }) => {
  const columns = [
    { key: "label", header: "Cert Number" },
    { key: "itemCodeName", header: "Item Code" },
    showTick && { key: "tickRating", header: "Tick Rating", render: (r) => tickLabel(r.tickRating) },
  ];

  return (
    <>
      <div className="table-title mt-4">
        <h3>Certificate and Cost Allocation</h3>
      </div>
      <ReadOnlyTable
        columns={columns}
        rows={rows}
        rowKey={(r) => r.label}
        wrapperClassName="cost-allocation-list member-list"
      />
    </>
  );
};

export default CostAllocationTable;